module.exports = __webpack_public_path__ + "static/media/56.c548343c.jpg";